export default __webpack_public_path__ + "static/media/GoodMannersAtSchool_08.6440ef51.png";